export const FETCH_FORM_REQUEST = 'FETCH_FORM_REQUEST';
export const FETCH_FORM_SUCCESS = 'FETCH_FORM_SUCCESS';
export const FETCH_FORM_FAILURE = 'FETCH_FORM_FAILURE';
export const CERTIFY_FORM_REQUEST = 'CERTIFY_FORM_REQUEST';
export const CERTIFY_FORM_SUCCESS = 'CERTIFY_FORM_SUCCESS';
export const CERTIFY_FORM_FAILURE = 'CERTIFY_FORM_FAILURE';
export const SET_CERTIFIED_FORM_TYPE = 'SET_CERTIFIED_FORM_TYPE';
export const REFRESH_CERTIFIED_FORM_TYPE = 'REFRESH_CERTIFIED_FORM_TYPE';
export const RESET_CERTIFIED_FORM_TYPE = 'RESET_CERTIFIED_FORM_TYPE';
